import { compose } from "redux";
import { connect } from "react-redux";
import Add from "@material-ui/icons/Add";
import React, { PureComponent } from "react";
import { withStyles } from "@material-ui/core/styles";
import { Grid, Button, Typography } from "@material-ui/core";

import SidePanel from "features/planner/components/SidePanel";
import { getViewsFromState } from "features/planner/planner.selectors";
import CreateViewModal from "features/planner/components/View/CreateViewModal";
import ViewSidePanelItem from "features/planner/components/View/ViewSidePanelItem";

class ViewSidePanel extends PureComponent {
  render() {
    const { views, classes, togglePanel, viewId } = this.props;

    return (
      <SidePanel>
        <Grid container direction="column" spacing={4}>
          <Grid container item>
            <Grid item xs component={Typography} variant="h6">
              Views
            </Grid>
            <CreateViewModal>
              <Button
                size="small"
                variant="outlined"
                className={classes.addViewBtn}
              >
                <Add fontSize="small" />
              </Button>
            </CreateViewModal>
            <Button
              size="small"
              variant="outlined"
              onClick={togglePanel}
              className={classes.closeButton}
            >
              Close
            </Button>
          </Grid>
          <Grid container item>
            {views.map(view => (
              <ViewSidePanelItem
                view={view}
                key={view.get("id")}
                viewId={view.get("id")}
                selected={viewId.toString() === view.get("id").toString()}
              />
            ))}
          </Grid>
        </Grid>
      </SidePanel>
    );
  }
}

const styles = theme => ({
  closeBtn: {
    textTransform: "none",
  },
  addViewBtn: {
    height: "100%",
    minWidth: "unset",
    marginRight: theme.spacing(0.5),
  },
});

export default compose(
  connect(state => ({
    views: getViewsFromState(state),
  })),
  withStyles(styles),
)(ViewSidePanel);
